import { Route } from '@angular/router';
import { ConversationComponent } from './conversation/conversation.component';
import { ErrorComponent } from './error/error.component';

export const appRoutes: Route[] = [
  {
    path: 'c/:participantAuthKey',
    component: ConversationComponent,
  },
  {
    path: 'error',
    component: ErrorComponent,
  },
  {
    path: '**',
    redirectTo: 'error',
  },
];
